import React from 'react';
import './smallCard.css';
import Loader from '../loader';
import RetryReport from '../retryReport';

// Función para calcular el porcentaje de cambio
const calculatePercentageChange = (current, previous) => {
    if (previous === 0) return 0; // Evitar división por cero
    return ((current - previous) / Math.abs(previous)) * 100;
};

// Función de contenido común para cada item
const renderDataItem = (value, previousValue, formatter, unit) => (
    <span className={`${value > previousValue ? 'high' : (value < previousValue ? 'low' : 'normal')}`} style={{ textAlign: 'center' }}>
        {formatter(value)} {unit}
    </span>
);

const SmallCard = ({ title, data, unit, progress, isReady, error, fetchReport }) => {
    // Cálculo del porcentaje de cambio
    const percentageChange = calculatePercentageChange(data.currentValue, data.previousValue);
    const percentageChangeClass = percentageChange > 0 ? 'high' : (percentageChange < 0 ? 'low' : 'normal');

    return (
        <div className='dashboard_card card_small'>
            {error ?
                <RetryReport fetchReport={fetchReport} sectionNum={4} />
                :
                progress < 100 || isReady ? (
                    <Loader  progress={progress} />
                ) : (
                    <>
                        <div className='dashboard_card_header_container'>
                            <span className='dashboard_card_title'>{title}</span>
                        </div>
                        <div className={`dashboard_card_content_container `}>
                            <div className='values_container'>
                                <span className={`${percentageChangeClass}`}>{data.currentValue.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                <div>
                                    <span className={percentageChangeClass}>
                                        {percentageChange.toFixed(2)}% {percentageChange > 0 ? '⬆' : (percentageChange < 0 ? '⬇' : '')}
                                    </span>
                                    <span>{unit}</span>
                                </div>
                            </div>
                            <span>En periodos anteriores: {data.previousValue.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}</span>
                        </div>
                    </>
                )}
        </div>
    );
};

export default SmallCard;
